import React from 'react';
import { CheckCircleIcon, ShieldCheckIcon, TruckIcon, WrenchIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
interface ColumnDef {
  key: string;
  label: string;
  sublabel: string;
  highlight: boolean;
}
const columns: ColumnDef[] = [{
  key: 'sca',
  label: 'SCA',
  sublabel: 'Standard',
  highlight: false
}, {
  key: 'scb',
  label: 'SCB',
  sublabel: 'Standard',
  highlight: false
}, {
  key: 'adv',
  label: 'SCB',
  sublabel: 'Advanced',
  highlight: false
}, {
  key: 'raptor',
  label: 'RAPTOR',
  sublabel: 'Heavy Duty',
  highlight: true
}];
interface SpecRow {
  label: string;
  values: (string | {
    text: string;
    bold?: boolean;
  })[];
}
const specs: SpecRow[] = [{
  label: 'Optimalna nosivost',
  values: ['150 – 180 kg', '150 – 200 kg', '180 – 220 kg', {
    text: '200 – 250 kg',
    bold: true
  }]
}, {
  label: 'Brzina kretanja',
  values: ['Varijabilna (0-100%)', 'Varijabilna (0-100%)', 'Varijabilna (0-100%)', 'Varijabilna (0-100%)']
}, {
  label: 'Kontrola',
  values: ['Precizni potenciometar', 'Precizni potenciometar', 'Precizni potenciometar', 'Precizni potenciometar']
}, {
  label: 'Zaštitni premaz',
  values: ['Mat industrijska boja', 'Mat industrijska boja', 'Gumirana zaštita', {
    text: 'Raptor Anti-scratch',
    bold: true
  }]
}, {
  label: 'Habanje tereta',
  values: ['Standardna zaštita', 'Standardna zaštita', 'Neklizajući sloj', {
    text: 'Maksimalna ✔',
    bold: true
  }]
}, {
  label: 'Baterija',
  values: ['48V Litijum (1 set)', '48V Litijum (1 set)', '48V Litijum (1 set)', {
    text: 'Dual-Power (2 seta)',
    bold: true
  }]
}, {
  label: 'Težina mašine',
  values: ['35 kg', '37 kg', '40 kg', {
    text: '40 kg (Ojačana)',
    bold: true
  }]
}, {
  label: 'Dimenzije',
  values: ['65×56×120-180 cm', '65×56×120-180 cm', '65×56×120-180 cm', '65×56×120-180 cm']
}];
const prices = ['€1,990', '€2,190', '€2,290', '€2,390'];
function SpecValue({
  value,
  isHighlightCol
}: {
  value: string | {
    text: string;
    bold?: boolean;
  };
  isHighlightCol: boolean;
}) {
  if (typeof value === 'string') {
    return <span className={`text-sm ${isHighlightCol ? 'text-white' : 'text-gray-300'}`} data-id="element-459">
        {value}
      </span>;
  }
  return <span className={`text-sm font-semibold ${value.bold ? 'text-brand-yellow' : isHighlightCol ? 'text-white' : 'text-gray-300'}`} data-id="element-460">
      {value.text}
    </span>;
}
export function ProductComparison() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const specs: SpecRow[] = [{
    label: en ? 'Drive system' : ru ? 'Привод' : 'Pogonski sistem',
    values: [{
      text: en ? 'Wheels + gear lift' : ru ? 'Колёса + шестерёнчатый подъёмник' : 'Točkovi + zupčasti podizač',
      bold: true
    }, en ? 'Tracks' : ru ? 'Гусеницы' : 'Gusenice', en ? 'Tracks' : ru ? 'Гусеницы' : 'Gusenice', en ? 'Tracks' : ru ? 'Гусеницы' : 'Gusenice']
  }, {
    label: en ? 'Optimal capacity' : ru ? 'Оптимальная грузоподъёмность' : 'Optimalna nosivost',
    values: ['150 – 180 kg', '150 – 200 kg', '180 – 220 kg', {
      text: '200 – 250 kg',
      bold: true
    }]
  }, {
    label: en ? 'Movement speed' : ru ? 'Скорость движения' : 'Brzina kretanja',
    values: [en ? 'Variable (0-100%)' : ru ? 'Переменная (0-100%)' : 'Varijabilna (0-100%)', en ? 'Variable (0-100%)' : ru ? 'Переменная (0-100%)' : 'Varijabilna (0-100%)', en ? 'Variable (0-100%)' : ru ? 'Переменная (0-100%)' : 'Varijabilna (0-100%)', en ? 'Variable (0-100%)' : ru ? 'Переменная (0-100%)' : 'Varijabilna (0-100%)']
  }, {
    label: en ? 'Control' : ru ? 'Управление' : 'Kontrola',
    values: [en ? 'Precision potentiometer' : ru ? 'Точный потенциометр' : 'Precizni potenciometar', en ? 'Precision potentiometer' : ru ? 'Точный потенциометр' : 'Precizni potenciometar', en ? 'Precision potentiometer' : ru ? 'Точный потенциометр' : 'Precizni potenciometar', en ? 'Precision potentiometer' : ru ? 'Точный потенциометр' : 'Precizni potenciometar']
  }, {
    label: en ? 'Protective coating' : ru ? 'Защитное покрытие' : 'Zaštitni premaz',
    values: [en ? 'Matte industrial paint' : ru ? 'Матовая промышленная краска' : 'Mat industrijska boja', en ? 'Matte industrial paint' : ru ? 'Матовая промышленная краска' : 'Mat industrijska boja', en ? 'Rubberized protection' : ru ? 'Прорезиненная защита' : 'Gumirana zaštita', {
      text: 'Raptor Anti-scratch',
      bold: true
    }]
  }, {
    label: en ? 'Cargo wear' : ru ? 'Износ груза' : 'Habanje tereta',
    values: [en ? 'Standard protection' : ru ? 'Стандартная защита' : 'Standardna zaštita', en ? 'Standard protection' : ru ? 'Стандартная защита' : 'Standardna zaštita', en ? 'Non-slip layer' : ru ? 'Противоскользящий слой' : 'Neklizajući sloj', {
      text: en ? 'Maximum ✔' : ru ? 'Максимальная ✔' : 'Maksimalna ✔',
      bold: true
    }]
  }, {
    label: en ? 'Battery' : ru ? 'Аккумулятор' : 'Baterija',
    values: [en ? '48V Lithium (1 set)' : ru ? '48В Литий (1 комплект)' : '48V Litijum (1 set)', en ? '48V Lithium (1 set)' : ru ? '48В Литий (1 комплект)' : '48V Litijum (1 set)', en ? '48V Lithium (1 set)' : ru ? '48В Литий (1 комплект)' : '48V Litijum (1 set)', {
      text: en ? 'Dual-Power (2 sets)' : ru ? 'Dual-Power (2 комплекта)' : 'Dual-Power (2 seta)',
      bold: true
    }]
  }, {
    label: en ? 'Machine weight' : ru ? 'Вес машины' : 'Težina mašine',
    values: ['35 kg', '37 kg', '40 kg', {
      text: en ? '40 kg (Reinforced)' : ru ? '40 кг (Усиленная)' : '40 kg (Ojačana)',
      bold: true
    }]
  }, {
    label: en ? 'Dimensions' : ru ? 'Размеры' : 'Dimenzije',
    values: ['65×56×120-180 cm', '65×56×120-180 cm', '65×56×120-180 cm', '65×56×120-180 cm']
  }];
  return <div className="space-y-10" data-id="element-461">
      {/* Cards Grid */}
      <div className="overflow-x-auto -mx-4 sm:mx-0 pb-4 snap-x snap-mandatory scrollbar-hide" data-id="element-462">
        <div className="flex gap-4 min-w-max px-4 sm:px-0 sm:min-w-0 sm:grid sm:grid-cols-4" data-id="element-463">
          {columns.map((col, colIdx) => {
          const isHero = col.highlight;
          return <div key={col.key} className={`
                  relative flex flex-col w-[280px] sm:w-auto snap-center rounded-2xl border overflow-hidden
                  ${isHero ? 'border-brand-yellow/60 bg-gradient-to-b from-brand-yellow/10 via-dark-surface to-dark-surface shadow-[0_0_40px_-8px_rgba(250,204,21,0.2)]' : 'border-brand-yellow/20 bg-dark-surface/80 backdrop-blur-sm'}
                `} data-id="element-464">
                {/* Preporuka badge */}
                {isHero && <div className="absolute top-0 right-0 z-10" data-id="element-465">
                    <div className="bg-brand-yellow text-dark-bg text-[10px] font-black uppercase tracking-widest px-3 py-1 rounded-bl-lg" data-id="element-466">
                      {en ? 'Recommended' : ru ? 'Рекомендуем' : 'Preporuka'}
                    </div>
                  </div>}

                {/* Header */}
                <div className={`px-5 pt-6 pb-4 text-center ${isHero ? 'border-b border-brand-yellow/20' : 'border-b border-dark-border/40'}`} data-id="element-467">
                  <h3 className={`text-2xl font-black tracking-tight ${isHero ? 'text-brand-yellow' : 'text-white'}`} data-id="element-468">
                    {col.label}
                  </h3>
                  <p className={`text-sm uppercase tracking-widest mt-1 font-bold ${isHero ? 'text-brand-yellow/80' : 'text-brand-yellow/70'}`} data-id="element-469">
                    {col.sublabel}
                  </p>
                </div>

                {/* Price */}
                <div className={`px-5 py-5 text-center ${isHero ? 'border-b border-brand-yellow/20' : 'border-b border-dark-border/40'}`} data-id="element-470">
                  <p className={`text-3xl font-black ${isHero ? 'text-brand-yellow' : 'text-white'}`} data-id="element-471">
                    {prices[colIdx]}
                  </p>
                  <p className="text-[11px] text-gray-500 mt-1 uppercase tracking-wider" data-id="element-472">
                    {en ? 'excl. VAT' : ru ? 'без НДС' : 'bez PDV'}
                  </p>
                </div>

                {/* Specs */}
                <div className="flex-1 px-5 py-4" data-id="element-473">
                  {specs.map((row, rowIdx) => <div key={row.label} className={`py-3 ${rowIdx < specs.length - 1 ? isHero ? 'border-b border-brand-yellow/10' : 'border-b border-dark-border/30' : ''}`} data-id="element-474">
                      <p className={`text-[10px] uppercase tracking-wider mb-1 ${isHero ? 'text-brand-yellow/50' : 'text-gray-500'}`} data-id="element-475">
                        {row.label}
                      </p>
                      <SpecValue value={row.values[colIdx]} isHighlightCol={isHero} data-id="element-476" />
                    </div>)}
                </div>
              </div>;
        })}
        </div>
      </div>

      {/* Notes */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-477">
        <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/40 rounded-xl px-5 py-4" data-id="element-478">
          <div className="w-8 h-8 rounded-full bg-brand-yellow/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-479">
            <ShieldCheckIcon className="w-4 h-4 text-brand-yellow" data-id="element-480" />
          </div>
          <div data-id="element-481">
            <p className="text-sm text-gray-300" data-id="element-482">
              {en ? <>
                  Factory warranty of{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-483">
                    one year
                  </span>{' '}
                  for all legal entities.
                </> : ru ? <>
                  Заводская гарантия{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-484">
                    один год
                  </span>{' '}
                  для всех юридических лиц.
                </> : <>
                  Fabrička garancija{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-485">
                    godinu dana
                  </span>{' '}
                  za sva pravna lica.
                </>}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/40 rounded-xl px-5 py-4" data-id="element-486">
          <div className="w-8 h-8 rounded-full bg-brand-yellow/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-487">
            <WrenchIcon className="w-4 h-4 text-brand-yellow" data-id="element-488" />
          </div>
          <div data-id="element-489">
            <p className="text-sm text-gray-300" data-id="element-490">
              {en ? 'Network of expert service technicians, original parts and operational training.' : ru ? 'Сеть квалифицированных сервисных специалистов, оригинальные запчасти и обучение работе.' : 'Mreža stručnih servisera, originalni delovi i obuka za rad.'}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/40 rounded-xl px-5 py-4" data-id="element-491">
          <div className="w-8 h-8 rounded-full bg-brand-yellow/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-492">
            <TruckIcon className="w-4 h-4 text-brand-yellow" data-id="element-493" />
          </div>
          <div data-id="element-494">
            <p className="text-sm text-gray-300" data-id="element-495">
              {en ? <>
                  Delivery up to{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-496">
                    60 days
                  </span>{' '}
                  directly from production.
                </> : ru ? <>
                  Доставка до{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-497">
                    60 дней
                  </span>{' '}
                  напрямую с производства.
                </> : <>
                  Isporuka do{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-498">
                    60 dana
                  </span>{' '}
                  direktno iz proizvodnje.
                </>}
            </p>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <p className="text-[11px] text-gray-600 leading-relaxed text-center max-w-2xl mx-auto" data-id="element-499">
        {en ? 'Note: The stated capacity is designed for optimal operation and motor longevity. Constant overloading above the upper limit is not recommended.' : ru ? 'Примечание: Указанная грузоподъёмность рассчитана на оптимальную работу и долговечность мотора. Постоянная перегрузка выше верхнего предела не рекомендуется.' : 'Napomena: Navedena nosivost je projektovana za optimalan rad i dugovečnost motora. Ne preporučuje se konstantno preopterećenje preko gornje granice.'}
      </p>
    </div>;
}